import React, { Component } from 'react';
import { Text } from '@components-library/Typography';
import { keyMap } from '@locales/lokalise/keyMap';
import cn from 'classnames';
import { FormValuesType } from 'components/shared/forms/formField.interface';
import { observer } from 'mobx-react';
import { TableHeaderCell } from '../tableHeaderCell/tableHeaderCell';
import { TableHeaderProps } from '../types';

class TableHeader extends Component<TableHeaderProps> {
  onFilter = (key: string, value: FormValuesType) => {
    const { onFilter, headerFilterValues } = this.props;

    const filterValues = { ...headerFilterValues };

    filterValues[key] = value;

    onFilter(filterValues);
    this.props.changePage(0);
  };

  generateTableNames() {
    const {
      columns,
      toggleRowsSelection,
      data,
      selectedRowsIds = [],
      tableHasExtensions,
      headerFilterValues,
      headerFilterDefaultValues,
      getSortedData,
      headerSortValues,
      selectByColumnName,
    } = this.props;
    const cols = columns || [];
    const handleSelectAllChange = () => {
      tableHasExtensions &&
        selectByColumnName &&
        toggleRowsSelection(data.map((d) => d[selectByColumnName]).filter(Boolean) as number[]);
    };

    return cols.map((col) =>
      col.key === 'checkbox' ? (
        // eslint-disable-next-line multiline-ternary
        <th key={col.key} className={col.className}>
          <label className="table__checkbox">
            <input
              type="checkbox"
              className="table__checkbox-input"
              checked={selectedRowsIds.length === data.length}
              onChange={handleSelectAllChange}
            />
            <span className="table__checkbox-label" />
          </label>
        </th>
      ) : (
        <TableHeaderCell
          key={col.key}
          column={col}
          headerFilterValues={headerFilterValues}
          headerFilterDefaultValues={headerFilterDefaultValues}
          onFilter={this.onFilter}
          getSortedData={getSortedData}
          headerSortValues={headerSortValues}
        />
      ),
    );
  }

  render() {
    const { actions, withStickyAction } = this.props;

    return (
      <thead>
        <tr>
          {this.generateTableNames()}
          {actions && (
            <th className={cn('t-align-right', withStickyAction && 'table__sticky-action')}>
              <Text>{keyMap.sharedActionsActions}</Text>
            </th>
          )}
        </tr>
      </thead>
    );
  }
}

export default observer(TableHeader);
